var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match_items"},[_c('div',{staticClass:"match_item"},_vm._l((_vm.matches),function(group){return _c('div',{staticClass:"match_item-content"},[_c('link-results-group',{attrs:{"group":group}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }